import React from "react";

const Music: React.FC = () => {
  return (
    <div className="section">
      <p>
        I am trained in Carnatic (South Indian classical) vocal music.
        I've been learning for over 20 years and have given concerts both in the US and India.
      </p>
    </div>
  );
};

export default Music;
